import React from 'react';
import clsx from 'clsx';
import { MediaZoom } from './MediaZoom.js';
const MAX_VISIBLE_IMAGES = 5;
export const MediaGallery = ({ images, className, }) => {
    let imagesPerRow;
    if (images.length === 1) {
        imagesPerRow = [1];
    }
    else if (images.length === 2) {
        imagesPerRow = [2];
    }
    else if (images.length === 3) {
        imagesPerRow = [1, 2];
    }
    else if (images.length === 4) {
        imagesPerRow = [1, 3];
    }
    else if (images.length >= MAX_VISIBLE_IMAGES) {
        imagesPerRow = [2, 3];
    }
    const hasMore = images.length > MAX_VISIBLE_IMAGES;
    const moreThumbnail = hasMore ? images[MAX_VISIBLE_IMAGES] : undefined;
    const invisibleImages = images.slice(MAX_VISIBLE_IMAGES);
    const firstRow = images.slice(0, imagesPerRow[0]);
    const firstRowMarkup = firstRow.map(image => (React.createElement(MediaZoom.Item, { key: image.id, item: image, className: firstRow.length === 2 ? 'col-span-3' : 'col-span-6' })));
    const secondRow = images.slice(imagesPerRow[0], imagesPerRow[0] + imagesPerRow[1]);
    const secondRowMarkup = secondRow.map(image => (React.createElement(MediaZoom.Item, { key: image.id, item: image, className: secondRow.length === 3 ? 'col-span-2' : 'col-span-3' })));
    if (moreThumbnail) {
        const moreThumbnailMarkup = (React.createElement(MediaZoom.Item, { key: moreThumbnail.id, item: moreThumbnail }, ({ open }) => (React.createElement("button", { type: "button", onClick: open, className: secondRow.length === 3 ? 'col-span-2' : 'col-span-3' },
            React.createElement(MoreIndicator, { moreCount: images.length - MAX_VISIBLE_IMAGES },
                React.createElement("img", { src: moreThumbnail.thumbnail, alt: moreThumbnail.alt, className: "bg-surface-subdued h-full w-full object-cover object-center" }))))));
        secondRowMarkup[secondRow.length - 1] = moreThumbnailMarkup;
    }
    return (React.createElement("div", { className: clsx('grid grid-cols-6 gap-1', className) },
        firstRowMarkup,
        secondRowMarkup,
        invisibleImages.map(image => (React.createElement(MediaZoom.Item, { key: image.id, item: image, skipRender: true })))));
};
const MoreIndicator = ({ moreCount, children, }) => {
    return (React.createElement("div", { className: "relative h-full w-full" },
        React.createElement("div", { className: clsx('absolute inset-0 bg-surface-inverse opacity-60') }),
        React.createElement("div", { className: clsx('absolute inset-0 flex items-center justify-center text-content-on-inverse opacity-80 text-lg font-medium leading-none') },
            "+",
            moreCount),
        children));
};
//# sourceMappingURL=MediaGallery.js.map